import { classNames } from "@op/opds.opux"
import React from "react"
import { ReactComponent } from "../svgs/illustration-insurance-valuable-general.svg"

const IconCategoryValuables = ({ className, ...props }) => (
  <ReactComponent aria-hidden={true} {...props} className={classNames("insurance-icon", className)} />
)

IconCategoryValuables.displayName = "IconCategoryValuables"
export default IconCategoryValuables
